import './index.css'
import { mountCrucialReact } from './crucialReactMount'
import { renderCrucialRoot } from './renderCrucialRoot'
import StudyModeQuestion, { type StudyModeConfig } from './StudyModeQuestion'
import { type ThemeMode, withHostTheme } from './themeHandler'

const ThemedStudyModeQuestion = withHostTheme(
  ({ config, theme }: { config: StudyModeConfig; theme: ThemeMode }) => (
    <StudyModeQuestion {...config} theme={theme} />
  ),
)

mountCrucialReact<StudyModeConfig>('StudyModeQuestion', (root, config) => {
  if (!config?.question) return

  renderCrucialRoot(
    root,
    'StudyModeQuestion',
    <ThemedStudyModeQuestion config={config} />,
  )
})
